import { UserlogsService } from './shared/userlogs.service';
import { DashboardRoutingModule } from './dashboard.routing.module';
import { DashboardComponent } from './dashboard.component';

import { FilterPipe } from '../shared/pipes/filter.pipe';
import { SharedModule } from '../shared/shared.module';
import { CommonModule, JsonPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
import { MarkdownModule } from 'angular2-markdown';
import { DashboardMapComponent } from './dashboard-map/dashboard-map.component';

@NgModule({
  imports: [DashboardRoutingModule, CommonModule, SharedModule],
  declarations: [DashboardComponent,
    DashboardMapComponent
  ],
  providers: [JsonPipe, UserlogsService],
  exports: [DashboardComponent]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/dashboard/dashboard.module.ts